// extracted by mini-css-extract-plugin
export default {"area":"DropDownWithLabel_area__rYOi8","label":"DropDownWithLabel_label__wRt3d","errorMessage":"DropDownWithLabel_errorMessage__MnwUw"};